<template>
  <section
    id="intro"
    class="text-center"
  >
    <h1 class="display-2 lushary--text font-weight-light mb-8">
      Мои работы
    </h1>

    <v-responsive
      class="mx-auto subtitle-1 grey--text"
      max-width="550"
    >
      Фотограф — творческая профессия. В данную область приходят люди, имеющие способности и художественные и дизайнерские навыки. Невозможно себе представить фотографа, у которого нет художественного вкуса.
    </v-responsive>
  </section>
</template>

<script>
  export default {
    name: 'PortfolioHeadline',
  }
</script>
